
//图例排序
export function reverseMapLegend(selectedSLDFile){
  let legendsData_reverse = [];
  let legendsDataAry= selectedSLDFile["sld:ColorMapEntry"];

  let Has_NOData = undefined;
  for(let i=legendsDataAry.length-1;i>=0;i--){
    let item = legendsDataAry[i];
    let item_deepCopy = JSON.parse(JSON.stringify({label:item.label}));//字符深拷贝
    let label = item_deepCopy.label;
    label = label+""; //转换为字符窜

    if(label!=undefined){
      label = label.replace("<=","≤");
      label = label.replace(">=","≥");
    }

    label = label.trim();
    label = label.replace(" ","");
    item.label = label;

    if(label=="0"||label=="<=0"||label=="<0"){
      Has_NOData = true;
    }

    if(i==(legendsDataAry.length-1)){
      //最后一个最大值执行处理 |2021年1月17日11:28:04
      // let quantity = parseInt(item.quantity) + "0000";
      // item.quantity = parseInt(quantity);
    }
    legendsData_reverse.push(item);
  }

  if(Has_NOData==undefined){
    legendsData_reverse.push({"quantity":0,"color":"#ffffff","label":"NO DATA"})
  }

  return JSON.parse(JSON.stringify(legendsData_reverse));
}



// WEBPACK FOOTER //
// ./src/view/BSD/mapTools.js